module.exports = __webpack_public_path__ + "img/oneOrange.06c38a5d.jpg";